import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
} from '@angular/core';

import { TinySliderSettings } from 'tiny-slider';

import { ScreenModes } from './login-ad-slider.enum';
import { LoginAdSliderElement, LoginAdSliderList } from './login-ad-slider.model';
import { LoginAdSliderService } from './login-ad-slider.service';

@Component({
    selector: 'app-login-ad-slider',
    templateUrl: './login-ad-slider.component.html',
    styleUrls: ['./login-ad-slider.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LoginAdSliderComponent implements OnInit, AfterViewInit {

	public adSlides: Array<LoginAdSliderElement>;
	public screenMode: string;
	public adSliderSettings: TinySliderSettings = {
		mode: 'gallery',
		autoplay: true,
		autoHeight: false,
		autoWidth: false,
		nav: true,
	};

	constructor(
		private loginAdSliderService: LoginAdSliderService,
		private changeDetectorRef: ChangeDetectorRef,
		private zone: NgZone,
	) { }

	public ngOnInit(): void {
		this.setScreenMode();
		this.getAdSliders();
	}

	public ngAfterViewInit(): void {
		this.zone.runOutsideAngular(() => {
			window.onresize = () => {
				this.setScreenMode();
			};
		});
	}

	public getBackgroundImage(adSlide: LoginAdSliderElement): string {
		switch (this.screenMode) {
			case ScreenModes.MOBILE:
				return adSlide.MOBILE_FILE;
			case ScreenModes.TABLET:
				return adSlide.TABLET_FILE;
			case ScreenModes.DESKTOP:
				return adSlide.DESKTOP_FILE;

			default:
				return adSlide.DESKTOP_FILE;
		}
	}

	private setScreenMode(): void {
		if (window.innerWidth >= 0 && window.innerWidth < 768 && this.screenMode !== ScreenModes.MOBILE) {
			this.screenMode = ScreenModes.MOBILE;
			this.changeDetectorRef.markForCheck();
		} else if (window.innerWidth >= 768 && window.innerWidth < 1280 && this.screenMode !== ScreenModes.TABLET) {
			this.screenMode = ScreenModes.TABLET;
			this.changeDetectorRef.markForCheck();
		} else if (window.innerWidth >= 1280 && this.screenMode !== ScreenModes.DESKTOP) {
			this.screenMode = ScreenModes.DESKTOP;
			this.changeDetectorRef.markForCheck();
		}
	}

	private getAdSliders(): void {
		this.loginAdSliderService
			.getAdSliders()
			.subscribe((adSlides: LoginAdSliderList) => {
				this.adSlides = adSlides.elements;
				this.changeDetectorRef.markForCheck();
			});
	}
}
